import { getApiActionTypes } from '../../shared/store/storeHelpers';

export const fetchConsolidationFilingAttributesTypes = getApiActionTypes(
  'FILING_ATTRIBUTES/FETCH_CONSOLIDATION_FILING_ATTRIBUTES',
);
export const fetchEntityFilingAttributesTypes = getApiActionTypes(
  'FILING_ATTRIBUTES/FETCH_ENTITY_FILING_ATTRIBUTES',
);
